package com.islamicmedia.site.components

import androidx.compose.runtime.*
import com.islamicmedia.site.theme.*
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*

/**
 * Tile-picker hub for the available activities. Used both inside the analysis ProgressTracker
 * and inside the Profile menu's "Activities" entry on web. Mirrors the Compose Multiplatform
 * version on mobile.
 */
@Composable
fun ActivitiesScreen() {
    var selected by remember { mutableStateOf<String?>(null) }
    if (selected == null) {
        Div(attrs = {
            style {
                display(DisplayStyle.Flex)
                flexDirection(FlexDirection.Column)
                gap(10.px)
                padding(16.px)
            }
        }) {
            ActivityTile(label = "Stay on the Fitrah") { selected = "runner" }
            ActivityTile(label = "Get Your Dhikr On") { selected = "dhikr" }
        }
    } else {
        Div(attrs = { style { padding(16.px) } }) {
            // Back link
            Div(attrs = {
                onClick { selected = null }
                style {
                    display(DisplayStyle.InlineBlock)
                    padding(6.px, 12.px)
                    borderRadius(8.px)
                    fontSize(12.px)
                    color(Primary)
                    fontWeight(500)
                    cursor("pointer")
                    property("background", "rgba(14, 124, 123, 0.08)")
                    property("border", "1px solid rgba(14, 124, 123, 0.3)")
                    marginBottom(12.px)
                }
            }) { Text("\u2190 Back to activities") }

            when (selected) {
                "runner" -> FitrahRunnerGame()
                "dhikr" -> DhikrCounter()
            }
        }
    }
}

@Composable
private fun ActivityTile(label: String, onClick: () -> Unit) {
    Div(attrs = {
        onClick { onClick() }
        style {
            padding(14.px, 8.px)
            borderRadius(12.px)
            property("border", "1px solid ${Gray200}")
            property("text-align", "center")
            cursor("pointer")
            fontSize(14.px)
            fontWeight(600)
            color(Primary)
        }
    }) { Text(label) }
}
